exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-actions[_v-637c20fa]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:1rem;height:18px;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.search-actions__text[_v-637c20fa]{font-weight:400}.search-actions__text__bold[_v-637c20fa]{font-weight:600}.search-actions__left[_v-637c20fa]{min-width:0}.search-actions__left .search-actions__text[_v-637c20fa]{max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.search-actions__right[_v-637c20fa]{-ms-flex:0 0 auto;flex:0 0 auto}.search-actions__right button[_v-637c20fa]{border:none;background:none;color:#532aa2;font-size:16px}.search-actions__right button[_v-637c20fa]:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-637c20fa&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v3-components/Gallery/SearchActionsBar.vue
// module id = 292
// module chunks = 0